import React, { FC, useState } from 'react';
import { useQuery } from '@apollo/client';
import Loader from '@minecraft.loader';
import { ItalicText } from 'components/styles/Shared';
import appConfig from 'config/appConfig';
import { ulaUrl } from 'constants/env.constants';
import { GET_USERNAME } from 'graphqls/profile';
import { getUserCountryInstance } from 'utils/utility';
import { HomeLink, StyledHeader, StyledContainer, StyledLogo, Bar, UserItem, Logout, Nav, MenuIcon } from './styles';

const Header: FC = () => {
  const { data: usernameData, loading, error } = useQuery(GET_USERNAME);
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  const logoutUser = (): void => {
    localStorage.clear();
    window.location.replace(ulaUrl);
  };

  const userCountryInstance = getUserCountryInstance();
  return (
    <StyledHeader>
      <StyledContainer>
        <MenuIcon
          name={showMobileMenu ? 'close' : 'menu-hamburger'}
          onClick={(): void => setShowMobileMenu((oldState) => !oldState)}
        />
        <Nav $open={showMobileMenu}>
          <HomeLink to="/">
            <StyledLogo src={`${appConfig.cdnRoot}/images/logos/cn-horizontal.svg`} />
          </HomeLink>
          {userCountryInstance && (
            <Bar>
              <UserItem>
                {userCountryInstance}{' '}
                {usernameData?.currentUsername ? <ItalicText>- {usernameData?.currentUsername}</ItalicText> : ''}
                {loading && <Loader />}
                {error && <span>Error in fetching username</span>}
              </UserItem>
              <Logout onClick={(): void => logoutUser()}>Log Out</Logout>
            </Bar>
          )}
        </Nav>
      </StyledContainer>
    </StyledHeader>
  );
};

export default Header;
